package com.yendo.mx.utils

import androidx.compose.runtime.*
import androidx.compose.ui.platform.LocalFontFamilyResolver
import androidx.compose.ui.text.font.FontFamily
import org.jetbrains.compose.resources.Font
import yendo.shared.generated.resources.Res
import yendo.shared.generated.resources.NotoEmoji

@Composable
fun CargarFuentesEmojis(content: @Composable () -> Unit) {
    val fontFamilyResolver = LocalFontFamilyResolver.current
    val emojiFont = Font(Res.font.NotoEmoji)

    LaunchedEffect(emojiFont) {
        try {
            fontFamilyResolver.preload(FontFamily(emojiFont))
            println("YENDO: Fuente NotoEmoji precargada exitosamente.")
        } catch (e: Throwable) {
            println("YENDO: Error precargando NotoEmoji -> ${e.message}")
        }
    }

    content()
}
